import {
  FilterDocument,
  GroupByMode,
  HabitGroupBy,
  HabitSortingMode,
  TaskGroupBy,
  TaskType,
} from '@griply/types';
import { habitSortingModeToSortingMode } from '@griply/utils';

const habitGroupByToGroupByMode: Record<HabitGroupBy, TaskGroupBy> = {
  [HabitGroupBy.None]: GroupByMode.None,
  [HabitGroupBy.Goal]: GroupByMode.Goal,
  [HabitGroupBy.LifeArea]: GroupByMode.LifeArea,
  [HabitGroupBy.Priority]: GroupByMode.Priority,
};

export const buildHabitsFilterDocument = (
  habitGroupBy: HabitGroupBy | undefined,
  habitSortingMode: HabitSortingMode | undefined,
): FilterDocument => ({
  groupByMode: habitGroupBy
    ? habitGroupByToGroupByMode[habitGroupBy]
    : GroupByMode.None,
  sortingMode: habitSortingMode
    ? habitSortingModeToSortingMode[habitSortingMode]
    : null,
  // Hide only ended habits (`completedAt`); today-complete habits stay visible.
  showCompleted: false,
  filters: { type: { include: [TaskType.Habit] } },
});
